import { menuItems } from './menuItems'

const getAllMenuItems = menuItems.getAllMenuItems()

export {
    getAllMenuItems
}